import { MapPin } from "lucide-react";

type SelectedStreet = {
  street: string;
  city: string;
  postcode: string;
  state?: string;
};

interface AddressHouseNumberHintProps {
  visible: boolean;
  selectedStreet: SelectedStreet | null;
}

export function AddressHouseNumberHint({
  visible,
  selectedStreet,
}: AddressHouseNumberHintProps) {
  if (!visible || !selectedStreet) return null;

  return (
    <div className="rounded-md border border-primary/20 bg-primary/10 p-3">
      <p className="flex items-center gap-2 text-sm font-medium text-primary">
        <MapPin className="h-4 w-4" />
        Ausgewählt: {selectedStreet.street}, {selectedStreet.postcode} {selectedStreet.city}
      </p>
      <p className="mt-1 text-xs text-muted-foreground">
        Bitte jetzt die Hausnummer eingeben oder aus der Liste auswählen.
      </p>
    </div>
  );
}
